import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import startCase from 'lodash.startcase';
import BottomDrawer, { DrawerButtonsWrapper } from '../Drawer/Drawer';
import Button from '../Button/Button';
import { productLocationTypes } from '../../util/enum/api/productTypes';
import { parseEnumType } from '../../util/helpers/enumMappers';
import StorageCard from './StorageCard';

const StorageCardsWrapper = styled.div`
  display: flex;
  gap: 16px;
  justify-content: center;
  flex-wrap: wrap;
`;

const SelectStorageType = ({
  open,
  setOpen,
  wizardData,
  setWizardData,
  setOpenSelectVaultLocation,
  selectedPlan,
}) => {
  const { t } = useTranslation();
  const selectedVault = startCase(
    parseEnumType(
      productLocationTypes,
      wizardData?.selectedVault?.LocationType,
    ),
  );
  const handleSelectStorageType = () => {
    setOpen(false);
    setOpenSelectVaultLocation(false);
  };

  const cardTypes = [
    {
      id: 'standard',
      name: t('buyWizard.standardStorage'),
      price: t('buyWizard.standardStorageAmount'),
      ribbon: t('buyWizard.included'),
      info: t('buyWizard.standardStoragePriceInfo'),
      features: [
        {
          label: t('buyWizard.standardStorageFeaturesListItem1'),
          included: false,
        },
        {
          label: t('buyWizard.standardStorageFeaturesListItem2'),
          included: false,
        },
        {
          label: t('buyWizard.standardStorageFeaturesListItem3'),
          included: true,
        },
        {
          label: t('buyWizard.standardStorageFeaturesListItem4'),
          included: true,
        },
      ],
    },
    {
      id: 'premium',
      name: t('buyWizard.segregatedStorage'),
      price: t('buyWizard.segregatedStorageAmount'),
      ribbon: t('buyWizard.premium'),
      info: t('buyWizard.segregatedStoragePriceInfo'),
      features: [
        {
          label: t('buyWizard.segregatedStorageFeaturesListItem1'),
          included: true,
        },
        {
          label: t('buyWizard.segregatedStorageFeaturesListItem2'),
          included: true,
        },
        {
          label: t('buyWizard.segregatedStorageFeaturesListItem3'),
          included: true,
        },
        {
          label: t('buyWizard.segregatedStorageFeaturesListItem4'),
          included: true,
        },
      ],
    },
  ];

  return (
    <BottomDrawer
      isOpen={open}
      onClose={() => setOpen(false)}
      title={t('buyWizard.chooseStorageType')}
      subtitle={t('buyWizard.selectedVault', { selectedVault })}
      footer={
        <DrawerButtonsWrapper>
          <Button
            variant="primaryOutlined"
            textTransform="none"
            onClick={() => setOpen(false)}
          >
            {t('buyWizard.backToVaults')}
          </Button>
          <Button
            variant="primary"
            textTransform="none"
            onClick={handleSelectStorageType}
          >
            {t('common.continue')}
          </Button>
        </DrawerButtonsWrapper>
      }
    >
      <StorageCardsWrapper>
        {cardTypes.map((type) => (
          <StorageCard
            key={type.id}
            cardType={type}
            variant={type.id}
            selected={selectedPlan === type.id}
            onSelect={(planId) =>
              setWizardData({ ...wizardData, selectedPlan: planId })
            }
          />
        ))}
      </StorageCardsWrapper>
    </BottomDrawer>
  );
};

SelectStorageType.propTypes = {
  open: PropTypes.bool,
  setOpen: PropTypes.func,
  wizardData: PropTypes.shape({
    selectedVault: PropTypes.shape({
      LocationType: PropTypes.number,
    }),
  }),
  setWizardData: PropTypes.func,
  setOpenSelectVaultLocation: PropTypes.func,
  selectedPlan: PropTypes.PropTypes.shape({}),
};

export default SelectStorageType;
